// Lot 743 — recherche « partout » dans Admin › Paramètres : réglages (index statique), modules, garde-fous et outils de
// maintenance dans UNE seule barre. Accents ignorés ; chaque mot tapé doit se trouver dans le libellé ou les mots-clés
// (explications ON/OFF, clé technique, numéro de lot). Les résultats dont le libellé correspond passent en premier.
export const normalizeSearch = (v) => (v || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

const words = (q) => normalizeSearch(q).trim().split(/\s+/).filter(Boolean);

export const buildSettingsIndex = ({ statics = [], features = [], guards = [], maintJobs = [] }) => [
  ...statics.map((e) => ({ kind: "Réglage", keywords: "", ...e })),
  ...features.map((f) => ({ kind: "Module", label: f.label, tab: "identity", target: `feat-row-${f.key}`, keywords: `${f.key} ${f.hint ? f.hint(true) + " " + f.hint(false) : ""}` })),
  ...guards.map((g) => ({ kind: "Garde-fou", label: g.label, tab: "identity", target: `guard-row-${g.key}`, keywords: `${g.key} lot ${g.lot || ""} ${g.hint(true)} ${g.hint(false)}` })),
  ...maintJobs.map((j) => ({ kind: "Maintenance", label: j.title, tab: "system", target: `maint-card-${j.key}`, keywords: `${j.key} ${j.desc || ""}` })),
];

export const searchSettings = (index, query, limit = 40) => {
  const ws = words(query);
  if (!ws.length) return [];
  const out = [];
  for (const e of index) {
    const label = normalizeSearch(e.label);
    const all = `${label} ${normalizeSearch(e.keywords)}`;
    if (!ws.every((w) => all.includes(w))) continue;
    out.push({ ...e, rank: ws.every((w) => label.includes(w)) ? 0 : 1 });
  }
  return out.sort((a, b) => a.rank - b.rank).slice(0, limit);
};
